<template>
  <v-btn
    :disabled="disabled"
    :color="selected ? 'secondary' : ''"
    :elevation="selected ? 2 : 0"
    block
    @click="$emit('click')"
  >
    <v-icon>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PosteBtn',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    poste: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getIcon: 'posteAIM/getIconePourPosteAimId',
    }),
    icon() {
      return this.getIcon(this.poste.posteAIMId)
    },
  },
  emits: ['click'],
}
</script>
